import posthog from "posthog-js";

// PostHog product analytics (POS2-940). Everything is gated on VITE_POSTHOG_KEY so
// the integration no-ops cleanly in local/dev where no key is set — mirroring the
// Sentry gating in main.tsx. Read inside each call so tests can stub the env.
function posthogKey(): string | undefined {
  return import.meta.env.VITE_POSTHOG_KEY;
}

/**
 * Initialise PostHog once at app bootstrap. Pageview + autocapture stay on by
 * default (this ticket's scope); person profiles are created only for identified
 * users. Defaults to the EU cloud when no host is set (data residency).
 */
export function initPosthog(): void {
  const key = posthogKey();
  if (!key) return;
  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com",
    person_profiles: "identified_only",
  });
}

/** Attribute events to the signed-in user by email (POS2-940). */
export function identifyUser(userId: string, email: string | undefined): void {
  if (!posthogKey()) return;
  posthog.identify(userId, email ? { email } : undefined);
}

/** Drop the identified user on logout so later events aren't misattributed. */
export function resetUser(): void {
  if (!posthogKey()) return;
  posthog.reset();
}
